var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ArrowBack, ChevronRightRounded, ExpandLessRounded, InsertLinkOutlined } from "@mui/icons-material";
import { Grid, Typography } from "@mui/material";
import dayjs from "dayjs";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { CrossSvgIcon, ShareLineSvgIcon } from "../../../assets/customIcons";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { MuiStack } from "../../../components";
import StatusColor from "../../../components/atoms/statusColor";
import { ElabelStyling } from "../../../constants";
import { showNotification } from "../../../redux/commonSlice";
import { useAppSelector } from "../../../store/hooks";
import { faintblue } from "../../../theme/palette";
import { systemColor } from "../../../theme/systemColor";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { DownloadIconSVG, PrintIconSVG } from "../../spareParts/purchaseRequistion/assets/customIcons";
import { purchaseRequisitionGetAPICall } from "../../spareParts/purchaseRequistion/services/apiCall";
import { DiscardPopup } from "../components/discardPopUp";
import PartDetails from "../components/partDetails";
import { createPuchaseOrderAPI, departmentPickListApiCall, getPurchaseOrderAPICall, organizationAddressPickListAPI, paymentMethodApiCall, paymentTermApiCall, priorityPickListApiCall, purchaseOrderAttachmentDelete, purchaseOrderUpdateAPICall, purchaseProcurementGetAPI, searchPurchaseNo, shippingMethodPickListApiCall, shippingTermPickListApiCall, supplierPickListApiCall, uploadPurchaseOrderAttachment, wareHousePickListApiCall } from "../services/apiCalls";
import { PurchaseOrderKeys } from "../services/entity";
export var CreatePurchaseOrder = function () {
    var _getPurchaseOrderById5, _getPurchaseOrderById6, _PurchaseRequisitionG;
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var _a = useState(false), openDiscardPopUp = _a[0], setOpenDiscardPopUp = _a[1];
    var _b = useState(false), priority = _b[0], setPriority = _b[1];
    var _c = useState(), grandTotal = _c[0], setGrandTotal = _c[1];
    var _d = useState(null), anchorElem = _d[0], setAnchorElem = _d[1];
    var id = useParams().id;
    var _e = useAppSelector(function (state) { return state.crud; }), getPurchaseOrderByIdData = _e.getPurchaseOrderByIdData, PurchaseRequisitionGet = _e.PurchaseRequisitionGet;
    var userIdentityData = getLocalStorageItem("USER_LOGIN_DATA");
    var branch = getLocalStorageItem("SELECTED_BRANCH");
    useEffect(function () {
        var _getPurchaseOrderById, _getPurchaseOrderById3;
        if (getPurchaseOrderByIdData !== null && getPurchaseOrderByIdData !== void 0 && (_getPurchaseOrderById = getPurchaseOrderByIdData.data) !== null && _getPurchaseOrderById !== void 0 && _getPurchaseOrderById.PurchaseProcurementId) {
            var _getPurchaseOrderById2;
            purchaseRequisitionGetAPICall({
                request: {
                    id: getPurchaseOrderByIdData === null || getPurchaseOrderByIdData === void 0 || (_getPurchaseOrderById2 = getPurchaseOrderByIdData.data) === null || _getPurchaseOrderById2 === void 0 ? void 0 : _getPurchaseOrderById2.PurchaseProcurementId
                }
            });
        }
        if ((getPurchaseOrderByIdData === null || getPurchaseOrderByIdData === void 0 || (_getPurchaseOrderById3 = getPurchaseOrderByIdData.data) === null || _getPurchaseOrderById3 === void 0 || (_getPurchaseOrderById3 = _getPurchaseOrderById3.PurchaseOrderPriority) === null || _getPurchaseOrderById3 === void 0 ? void 0 : _getPurchaseOrderById3.Name) === "High") {
            setPriority(true);
        }
    }, [getPurchaseOrderByIdData === null || getPurchaseOrderByIdData === void 0 ? void 0 : getPurchaseOrderByIdData.data]);
    var handleCancelClose = function () {
        setOpenDiscardPopUp(false);
    };
    var onDiscardClick = function () {
        setOpenDiscardPopUp(true);
    };
    var getSupplierList = function (params) { return supplierPickListApiCall(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread(_objectSpread({}, params.request), {}, {
            ParentOrganizationId: branch === null || branch === void 0 ? void 0 : branch.ParentOrganizationId
        })
    })); };
    var getOrganizationAddress = function (params) { return organizationAddressPickListAPI(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread(_objectSpread({}, params.request), {}, {
            OrganizationId: branch === null || branch === void 0 ? void 0 : branch.OrganizationId
        })
    })); };
    var getWareHousePickList = function (params) { return wareHousePickListApiCall(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread(_objectSpread({}, params.request), {}, {
            TenantId: branch === null || branch === void 0 ? void 0 : branch.OrganizationId
        })
    })); };
    var handleSearchClick = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, purchaseProcurementGetAPI({
                        request: {
                            id: value === null || value === void 0 ? void 0 : value.id
                        }
                    })];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && result.data) {
                        return [2 /*return*/, result === null || result === void 0 ? void 0 : result.data];
                    }
                    else {
                        dispatch(showNotification({
                            isOpen: true,
                            message: "No requisition found",
                            type: "error"
                        }));
                        return [2 /*return*/];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var onClickSave = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var _userIdentityData$dat, _userIdentityData$dat2, req, res, _userIdentityData$dat3, _userIdentityData$dat4, req, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!id) return [3 /*break*/, 2];
                    req = _objectSpread(_objectSpread({}, value), {}, {
                        OrganizationId: branch === null || branch === void 0 ? void 0 : branch.OrganizationId,
                        ParentOrganizationId: branch === null || branch === void 0 ? void 0 : branch.ParentOrganizationId,
                        PurchaseOrderTypeId: "f7103eb3-4df7-474b-bd00-a33f1d7f7f01",
                        PurchaseOrderCreatedById: userIdentityData === null || userIdentityData === void 0 || (_userIdentityData$dat = userIdentityData.data) === null || _userIdentityData$dat === void 0 ? void 0 : _userIdentityData$dat.IdentityId,
                        // identity id
                        ApprovedById: userIdentityData === null || userIdentityData === void 0 || (_userIdentityData$dat2 = userIdentityData.data) === null || _userIdentityData$dat2 === void 0 ? void 0 : _userIdentityData$dat2.IdentityId,
                        ApproverRemarks: "",
                        IsScheduled: true,
                        ImageAttachments: []
                    });
                    return [4 /*yield*/, purchaseOrderUpdateAPICall({
                            request: req
                        })];
                case 1:
                    res = _a.sent();
                    if ((res === null || res === void 0 ? void 0 : res.statusCode) === 200)
                        navigate("/purchaseOrder");
                    return [3 /*break*/, 4];
                case 2:
                    req = _objectSpread(_objectSpread({}, value), {}, {
                        OrganizationId: branch === null || branch === void 0 ? void 0 : branch.OrganizationId,
                        ParentOrganizationId: branch === null || branch === void 0 ? void 0 : branch.ParentOrganizationId,
                        PurchaseOrderTypeId: "f7103eb3-4df7-474b-bd00-a33f1d7f7f01",
                        PurchaseOrderCreatedById: userIdentityData === null || userIdentityData === void 0 || (_userIdentityData$dat3 = userIdentityData.data) === null || _userIdentityData$dat3 === void 0 ? void 0 : _userIdentityData$dat3.IdentityId,
                        // identity id
                        ApprovedById: userIdentityData === null || userIdentityData === void 0 || (_userIdentityData$dat4 = userIdentityData.data) === null || _userIdentityData$dat4 === void 0 ? void 0 : _userIdentityData$dat4.IdentityId,
                        ApproverRemarks: "",
                        IsScheduled: true,
                        ImageAttachments: []
                    });
                    return [4 /*yield*/, createPuchaseOrderAPI({
                            request: _objectSpread({}, req)
                        })];
                case 3:
                    res = _a.sent();
                    if ((res === null || res === void 0 ? void 0 : res.statusCode) === 201) {
                        navigate("/purchaseOrder");
                    }
                    _a.label = 4;
                case 4: return [2 /*return*/, "submit"];
            }
        });
    }); };
    var handleClickGrandTotal = function (event) {
        setAnchorElem(event.currentTarget);
    };
    var searchParams = useSearchParams()[0];
    var generalDetailsForm = [{
            type: FormItemTypes.CardComponent,
            name: "",
            label: t("Basic details"),
            elements: [{
                    type: FormItemTypes.DatePicker,
                    name: "RequisitionDate",
                    label: "Requisition Date",
                    disabled: true
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: "WarehouseId",
                    label: "Warehouse",
                    displayExpr: "DisplayName",
                    valueExpr: "id",
                    getListData: getWareHousePickList,
                    apiKey: PurchaseOrderKeys.Warehouse
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: "DepartmentId",
                    label: "Department",
                    value: null,
                    displayExpr: "DisplayName",
                    valueExpr: "id",
                    getListData: departmentPickListApiCall,
                    apiKey: PurchaseOrderKeys.Department
                }, {
                    type: FormItemTypes.TextInput,
                    name: "PlaceofSupply",
                    label: "Place of supply"
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: "PurchaseOrderPriorityId",
                    label: "Priority",
                    getListData: priorityPickListApiCall,
                    apiKey: PurchaseOrderKeys.Priority,
                    onChange: function (e, value) {
                        setPriority(value.Name === "High");
                    }
                }, priority ? {
                    type: FormItemTypes.TextInput,
                    name: "PriorityRemarks",
                    label: "Priority reason",
                    multiline: true,
                    minRows: 2,
                    required: true,
                    placeholder: "Enter priority reason"
                } : null],
            columnSize: 12
        }, {
            type: FormItemTypes.CardComponent,
            name: "",
            label: 'Supplier details',
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: "SupplierId",
                    label: "Supplier",
                    value: null,
                    displayExpr: "Name",
                    valueExpr: "id",
                    getListData: getSupplierList,
                    apiKey: PurchaseOrderKeys.SupplierList,
                    setFormState: function (formValues, currValue, field) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, {
                                    PurchaseOrderDetails: []
                                }];
                        });
                    }); },
                    required: true
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: "ShippingAddressId",
                    label: "Bill to",
                    value: null,
                    displayExpr: "Address1",
                    valueExpr: "AddressId",
                    getListData: getOrganizationAddress,
                    apiKey: PurchaseOrderKeys.OrganizationAddress
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: "ShippingMethodId",
                    label: "Shipping Method",
                    value: null,
                    displayExpr: "DisplayName",
                    valueExpr: "id",
                    getListData: shippingMethodPickListApiCall,
                    apiKey: PurchaseOrderKeys.ShippingMethod
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: "ShippingTermId",
                    label: "Shipping term",
                    value: null,
                    displayExpr: "DisplayName",
                    valueExpr: "id",
                    getListData: shippingTermPickListApiCall,
                    apiKey: PurchaseOrderKeys.ShippingTerm
                }],
            columnSize: 12
        }];
    var additionalDetailsForm = [{
            type: FormItemTypes.CardComponent,
            name: "Customer & vehicle details",
            label: "Other information",
            elements: [{
                    type: FormItemTypes.DatePicker,
                    name: "ValidTillDateTime",
                    label: "Valid till date"
                }, {
                    type: FormItemTypes.DatePicker,
                    name: "EstimateDeliveryDateTime",
                    label: "Expected fulfilment date"
                }, {
                    type: FormItemTypes.TextInput,
                    name: "ReferenceNumber",
                    label: "Quotation/Reference no"
                }, {
                    type: FormItemTypes.DatePicker,
                    name: "PurchaseOrderCreatedDateTime",
                    label: "Quotation date"
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: "PaymentTermId",
                    label: "Payment term",
                    value: null,
                    displayExpr: "Name",
                    valueExpr: "PaymentTermId",
                    getListData: paymentTermApiCall,
                    apiKey: PurchaseOrderKeys.PaymentTerm
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: "PaymentTermMethodId",
                    label: "Payment method",
                    value: null,
                    displayExpr: "Name",
                    valueExpr: "PaymentTermMethodId",
                    getListData: paymentMethodApiCall,
                    apiKey: PurchaseOrderKeys.PaymentMethod
                }],
            columnSize: 12
        }, {
            type: FormItemTypes.CardComponent,
            name: "NotesAndAttachments",
            label: "Notes and attachments",
            columnSize: 12,
            variant: "outlined",
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: "DeliveryNotes",
                    label: "Delivery Notes(0/200 characters)",
                    maxLength: 200,
                    multiline: true,
                    minRows: 3,
                    md: 4
                }, {
                    type: FormItemTypes.TextInput,
                    name: "Remarks",
                    label: "Remarks(0/200 characters)",
                    multiline: true,
                    maxLength: 200,
                    minRows: 3,
                    md: 4
                }, {
                    type: FormItemTypes.Attachment,
                    name: "Attachments",
                    label: "Add attachments",
                    placeholder: "Upload Files",
                    value: null,
                    inputProps: {
                        accept: "application/*",
                        multiple: true
                    },
                    uploadAttachmentRequest: {
                        systemname: PurchaseOrderKeys.AttachmentSystemName
                    },
                    uploadAttachmentAPI: uploadPurchaseOrderAttachment,
                    deleteAttachmentAPI: purchaseOrderAttachmentDelete
                }]
        }];
    var partDetails = [{
            type: FormItemTypes.Custom,
            name: "PurchaseOrderDetails",
            label: "",
            value: null,
            columnSize: 12,
            element: PartDetails
        }, {
            type: FormItemTypes.CardComponent,
            name: "",
            columnSize: 12,
            variant: "outlined",
            elements: [{
                    type: FormItemTypes.Box,
                    name: "",
                    columnSize: true
                }, {
                    type: FormItemTypes.Button,
                    name: "GrandTotal",
                    label: "",
                    value: null,
                    columnSize: 4,
                    children: /*#__PURE__*/ React.createElement(Typography, {
                        sx: {
                            flexGrow: 1
                        },
                        fontWeight: "bold",
                        textAlign: "left"
                    }, "Grand Total"),
                    variant: "outlined",
                    fullWidth: true,
                    valueGetter: function (formValues, currValue) {
                        var _formValues$PurchaseO;
                        var totalSum = formValues === null || formValues === void 0 || (_formValues$PurchaseO = formValues.PurchaseOrderDetails) === null || _formValues$PurchaseO === void 0 ? void 0 : _formValues$PurchaseO.reduce(function (acc, data) {
                            return acc + data.ModifiedQuantity * data.Rate;
                        }, 0);
                        setGrandTotal(totalSum && totalSum);
                        return totalSum;
                    },
                    sx: {
                        justifyContent: "space-between",
                        bgcolor: "rgba(0,0,0,0.05)",
                        fontWeight: "bold",
                        color: systemColor.secondary
                    },
                    endIcon: grandTotal ? "\u20B9 ".concat(grandTotal) : "₹ 00.00",
                    setFieldProps: function (formValues, currValue) {
                        return {
                            type: this.type,
                            startIcon: formValues !== null && formValues !== void 0 && formValues.Open ? /*#__PURE__*/ React.createElement(ExpandLessRounded, null) : /*#__PURE__*/ React.createElement(ChevronRightRounded, null)
                        };
                    },
                    setFormState: function (formValues, e, field) {
                        return {
                            Open: !(formValues !== null && formValues !== void 0 && formValues.Open)
                        };
                    },
                    onClick: function (e, value) { return handleClickGrandTotal(e); }
                }]
        }];
    var tabs = [{
            id: "0",
            label: "General",
            elements: generalDetailsForm
        }, {
            id: "1",
            label: "Part details",
            elements: partDetails
        }, {
            id: "2",
            label: "Additional info",
            elements: additionalDetailsForm
        }];
    var formData = [
        // Page Header
        {
            type: FormItemTypes.ContainerItem,
            name: "pageHeader",
            columnSize: 12,
            justifyContent: "space-between",
            alignItems: "center",
            spacing: 0,
            gap: 1,
            p: 2,
            elements: [{
                    type: FormItemTypes.IconButton,
                    name: "",
                    columnSize: 0,
                    children: /*#__PURE__*/ React.createElement(ArrowBack, {
                        fontSize: "small",
                        onClick: function () { return navigate("/purchaseOrder"); }
                    })
                }, {
                    type: FormItemTypes.Typography,
                    name: "",
                    children: id ? "Edit purchase order" : "New purchase order",
                    columnSize: 0,
                    variant: "h1",
                    noWrap: true
                }, {
                    type: FormItemTypes.Custom,
                    name: "",
                    label: "",
                    value: null,
                    columnSize: 0,
                    element: function () {
                        var _getPurchaseOrderById4;
                        return id ? /*#__PURE__*/ React.createElement(MuiStack, {
                            sx: {
                                border: "1px solid #DEE4EB",
                                borderRadius: "6px",
                                gap: "5px",
                                padding: "3px 8px"
                            },
                            alignItems: "center"
                        }, /*#__PURE__*/ React.createElement(StatusColor, {
                            status: 
                            // documentDetailsGetById?.data?.Key
                            // ??
                            ""
                        }), /*#__PURE__*/ React.createElement(Typography, {
                            sx: {
                                width: 'max-content'
                            },
                            id: "statusKeyId",
                            variant: "h6"
                        }, getPurchaseOrderByIdData === null || getPurchaseOrderByIdData === void 0 || (_getPurchaseOrderById4 = getPurchaseOrderByIdData.data) === null || _getPurchaseOrderById4 === void 0 || (_getPurchaseOrderById4 = _getPurchaseOrderById4.Status) === null || _getPurchaseOrderById4 === void 0 ? void 0 : _getPurchaseOrderById4.Name)) : /*#__PURE__*/ React.createElement(React.Fragment, null);
                    }
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: null,
                    columnSize: true,
                    item: false,
                    justifyContent: "end",
                    spacing: 0,
                    elements: id ? [{
                            type: FormItemTypes.Typography,
                            name: "",
                            label: "PO NUMBER: ",
                            value: id ? getPurchaseOrderByIdData === null || getPurchaseOrderByIdData === void 0 || (_getPurchaseOrderById5 = getPurchaseOrderByIdData.data) === null || _getPurchaseOrderById5 === void 0 ? void 0 : _getPurchaseOrderById5.DocumentNumber : null,
                            columnSize: 0,
                            labelTypographyProps: {
                                color: "rgba(0,0,0,0.4)",
                                fontSize: 12,
                                fontWeight: 600
                            },
                            containerProps: {
                                display: "flex",
                                direction: "row",
                                alignItems: "center",
                                spacing: 0,
                                gap: 1,
                                px: 1
                            },
                            fontWeight: 400,
                            fontSize: 14
                        }, {
                            type: FormItemTypes.Typography,
                            name: "",
                            label: "PO DATE: ",
                            value: id ? dayjs(getPurchaseOrderByIdData === null || getPurchaseOrderByIdData === void 0 || (_getPurchaseOrderById6 = getPurchaseOrderByIdData.data) === null || _getPurchaseOrderById6 === void 0 ? void 0 : _getPurchaseOrderById6.CreatedOn).format("DD MMM, YYYY") : null,
                            columnSize: 0,
                            // valueFormatter: (value: any) => dayjs(value).format('DD MMM, YYYY'),
                            labelTypographyProps: {
                                color: "rgba(0,0,0,0.4)",
                                fontSize: 12,
                                fontWeight: 600
                            },
                            containerProps: {
                                display: "flex",
                                direction: "row",
                                alignItems: "center",
                                spacing: 0,
                                gap: 1,
                                px: 1
                            },
                            fontWeight: 400,
                            fontSize: 14
                        }] : []
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ActionPanel',
            columnSize: 12,
            spacing: 0,
            columnSpacing: 2,
            p: 2,
            minWidth: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignContent: 'flex-end',
            bgcolor: '#EFF2F5',
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: "PurchaseProcurementId",
                    displayExpr: "DocumentNumber",
                    getListData: searchPurchaseNo,
                    labelTypographyProps: ElabelStyling,
                    placeholder: "Search or select requisition no",
                    valueExpr: "id",
                    containerProps: {
                        display: id === undefined ? "" : "none",
                        marginLeft: 4
                    },
                    value: PurchaseRequisitionGet === null || PurchaseRequisitionGet === void 0 || (_PurchaseRequisitionG = PurchaseRequisitionGet.data) === null || _PurchaseRequisitionG === void 0 ? void 0 : _PurchaseRequisitionG.DocumentNumber,
                    columnSize: true,
                    setFormState: function (formValues, currValue, field) { return __awaiter(void 0, void 0, void 0, function () {
                        var data;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, handleSearchClick(currValue)];
                                case 1:
                                    data = _a.sent();
                                    return [2 /*return*/, {
                                            PurchaseOrderDetails: data === null || data === void 0 ? void 0 : data.PurchaseProcurementDetails,
                                            SupplierId: data === null || data === void 0 ? void 0 : data.SupplierId,
                                            PurchaseOrderPriorityId: data === null || data === void 0 ? void 0 : data.ProcurementPriorityId,
                                            ReferenceNumber: data === null || data === void 0 ? void 0 : data.ReferenceNumber,
                                            ValidTillDateTime: data === null || data === void 0 ? void 0 : data.ValidTillDateTime,
                                            EstimateDeliveryDateTime: data === null || data === void 0 ? void 0 : data.EstimateDeliveryDateTime,
                                            RequisitionDate: data === null || data === void 0 ? void 0 : data.CreatedOn
                                        }];
                            }
                        });
                    }); }
                }, {
                    type: FormItemTypes.TextInput,
                    name: "PurchaseProcurementId",
                    label: "",
                    value: null,
                    containerProps: {
                        display: id !== undefined ? "" : "none"
                    },
                    disabled: true,
                    columnSize: 4
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: "actionPanel",
                    label: "",
                    value: null,
                    columnSize: 8,
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "",
                            label: "",
                            value: null,
                            children: "Quick Links",
                            columnSize: 0,
                            variant: "text",
                            startIcon: /*#__PURE__*/ React.createElement(InsertLinkOutlined, null),
                            sx: {
                                background: "none"
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(DownloadIconSVG, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(PrintIconSVG, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Box,
                            name: "",
                            columnSize: 0,
                            height: "40px",
                            width: "2px",
                            bgcolor: "rgba(0,0,0,0.1)",
                            mx: 1
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(CrossSvgIcon, {
                                style: {
                                    height: "20px",
                                    width: "20px"
                                }
                            }),
                            onClick: function () { return onDiscardClick(); },
                            columnSize: 0,
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: "Save as draft",
                            columnSize: 0,
                            variant: "outlined"
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: "Save",
                            columnSize: 0,
                            variant: "contained",
                            onClick: function (e, value) {
                                onClickSave(value);
                            }
                        }],
                    justifyContent: "flex-end"
                }]
        }, {
            type: FormItemTypes.Tabs,
            name: "Stepper",
            label: "",
            value: "0",
            tabs: tabs,
            valueExpr: "id",
            displayExpr: "label",
            columnSize: 12,
            tabPanelProps: {
                sx: {
                    px: {
                        xs: 2,
                        sm: 2.5,
                        md: 3
                    }
                }
            },
            sx: {
                paddingX: {
                    xs: 2,
                    sm: 2.5,
                    md: 3
                },
                gap: 2.5
            },
            stackContainerProps: {
                sx: {
                    mb: {
                        xs: 7.5,
                        sm: 0
                    }
                }
            }
        }
    ];
    return /*#__PURE__*/ React.createElement(Grid, {
        bgcolor: faintblue
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        gridSpacing: 0,
        getFormAPI: getPurchaseOrderAPICall,
        getRequest: {
            id: id
        },
        getKey: PurchaseOrderKeys === null || PurchaseOrderKeys === void 0 ? void 0 : PurchaseOrderKeys.PurchaseOrderById,
        formData: formData,
        mode: id ? "edit" : "add"
    }), /*#__PURE__*/ React.createElement(DiscardPopup, {
        openPopper: openDiscardPopUp,
        handleClose: handleCancelClose
    }));
};
